//pinto home
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { MASTER_API } from '../../apiConfig';
import { getCurrentUser } from '../../utils/getCurrentUser';

const PinToHome = ({ tileId }) => {
    const [isPinned, setIsPinned] = useState(false);
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (!currentUser || !tileId) return;
        axios.get(`${MASTER_API}/favorites/${currentUser}`)
            .then(res => {
                if (res.data.favorites.includes(tileId)) {
                    setIsPinned(true);
                }
            }).catch(console.error);
    }, [tileId, currentUser]);

    const handleToggle = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!currentUser) {
            toast.error("User not found! Please re-login.");
            return;
        }

        const nextPinned = !isPinned;

        try {
            await axios.post(`${MASTER_API}/favorites/toggle`, {
                username: currentUser,
                tile_id: tileId,
                isPinned: nextPinned   // desired end-state; matches the fixed service
            });
            setIsPinned(nextPinned);
            toast.success(nextPinned ? "Pinned to Home" : "Removed from Home");
        } catch (error) {
            toast.error("Failed to update favorites");
        }
    };

    return (
        <div
            onClick={handleToggle}
            style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                cursor: 'pointer',
                fontSize: '22px',
                color: isPinned ? '#fbbf24' : '#e2e8f0', 
                transition: '0.2s',
                zIndex: 10
            }}
            title={isPinned ? "Unpin from Home" : "Pin to Home"}
        >
            {isPinned ? '★' : '☆'}
        </div>
    );
};

export default PinToHome;